module.exports = __webpack_public_path__ + "static/media/node-dot-js.acd118be.svg";